// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: 30,
        /* Optional */
        // loadProductFirst: true,
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'saleClass': 'on-sale',
    'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
    'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
    'vendorHtml': '<div>{{itemVendorLabel}}</div>',
    // Grid Template
    'productGridItemHtml': '<div>' +
                                '<div class="featured-product">' +
                                    '<a href="{{itemUrl}}">' +
                                        '<div>'+
                                            '<div class="product-tag {{itemSale}}">'+
                                                '<p class="tags-list">'+
                                                    '<span class="tag">'+
                                                        'sale'+
                                                    '</span>'+
                                                '</p>'+
                                            '</div>'+
                                            '<div class="product-image">'+
                                                '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}"/>'+
                                                '<p>{{itemTitle}}</p>'+
                                            '</div>'+
                                        '</div>'+
                                        '<div class="price">{{itemPrice}}</div>'+
                                        '{{PersonalisedText}}'+
                                        '<div class="product-card__overlay">'+
                                            '<span class="btn product-card__overlay-btn ">View</span>'+
                                        '</div>'+
                                    '</a>' +
                                '</div>' +
                            '</div>',

    // Pagination Template
    'pageFirstHtml': '<li class="first"><a href="{{itemUrl}}">First</a></li>',
    'previousActiveHtml': '<li class="previous"><a href="{{itemUrl}}">&larr;</a></li>',
    'previousDisabledHtml': '<li  class="disabled"><span>&larr;</span></li>',
    'nextActiveHtml': '<li class="next"><a href="{{itemUrl}}">&rarr;</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
    'pageItemHtml': '<li class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="active"><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li class="page"><span>{{itemTitle}}</span></li>',
    'pageLastHtml': '<li class="last"><a href="{{itemUrl}}">Last</a></li>',
    'paginateHtml': '<ul class="pagination-custom">{{first}}{{previous}}{{pageItems}}{{next}}{{last}}</ul>',
    
  
    // Sorting Template
    'sortingHtml': '<p>{{productsOnPage}}</p><div><label class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select class="collection-sort__input">{{sortingItems}}</select></div>',
};
/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
  
    var images = data.images_info;
  	var isAvailable = data.available;
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }

    if(images.length > 0) {
        var PersonalisedImgSrc = images[0]['src'].substr(0, images[0]['src'].indexOf('products')); 
    }
    
    var isPersonalised = false;
	

    if(data['tags'] != null) {
        for(var i = 0; i < data['tags'].length; i++){
            if(data['tags'][i].indexOf("Personalised") >= 0 || data['tags'][i].indexOf("Engraved") >= 0) {
                isPersonalised = true;
            }
        }
    }

    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Price
    var itemPriceHtml = '';
    if (data.title != '')  {
        if (onSale) {
            itemPriceHtml +='<p class="onsale-original">';
            if (priceVaries) {
                itemPriceHtml += (bcSfFilterConfig.label.on_sale_from_html).replace(/{{ price }}/g, this.formatMoney(data.price_min));
            } else {
                itemPriceHtml += this.formatMoney(data.price_min);
            }
            itemPriceHtml += '<s class="saleprice">' + this.formatMoney(data.compare_at_price_min) + '</s> </p>';
        }
        else{
            itemPriceHtml +='<p>';
            if (priceVaries) {
                itemPriceHtml += (bcSfFilterConfig.label.from_text_html).replace(/{{ price }}/g, this.formatMoney(data.price_min));
            } else {
                itemPriceHtml += this.formatMoney(data.price_min)+'</p>';
            }
        }
    }

    if(onSale){
       itemHtml = itemHtml.replace(/{{itemSale}}/g, "sale"); 
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
	
    if(isAvailable) {
      if(isPersonalised) {
           var PersonalisedText = '<p class="personalised"><span>Personalise this item</span></p>';
          itemHtml = itemHtml.replace(/{{PersonalisedText}}/g, PersonalisedText);
      } else {
          itemHtml = itemHtml.replace(/{{PersonalisedText}}/g, "");
      }
    } else {
      var PersonalisedText = '<p class="personalised unavailable"><span>Currently Unavailable</span></p>';
      itemHtml = itemHtml.replace(/{{PersonalisedText}}/g, PersonalisedText);
    }
  	
    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  
    // Add onSale class
    var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  
    // Add soldOut Label
    var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // Add onSale Label
    var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
    // // Add Description
    // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    // // Truncate by word
    // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
    // // Truncate by character
    // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
    // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        // Featured image
        if (data['images_info'] > 0) {
            data[k]['featured_image'] = data['images_info'][0];
        } else {
            data[k]['featured_image'] = {width: '', height: '', aspect_ratio: 0}
        }

        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};
var texttodisplay;
/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {

    if (this.getSettingValue('general.paginationType') == 'default') {
        
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
        var startingProduct = ((currentPage-1)*this.queryParams.limit);
        if(currentPage!= totalPage) {
            texttodisplay = "Showing "+(startingProduct+1) +" - "+(startingProduct+this.queryParams.limit)+" of "+totalProduct+" products";
        }
        else {
             texttodisplay = "Showing "+(startingProduct+1) +" - "+(startingProduct+( totalProduct - startingProduct))+" of "+totalProduct+" products";;
        }

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.bottomPagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            //Build First
            var pageFirstHtml = (currentPage > 1) ? bcSfFilterTemplate.pageFirstHtml: "";
            pageFirstHtml = pageFirstHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page',currentPage,1));
            paginationHtml = paginationHtml.replace(/{{first}}/g, pageFirstHtml);

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            //Build Last
            var pageLastHtml = (currentPage != totalPage) ? bcSfFilterTemplate.pageLastHtml: "";
            pageLastHtml = pageLastHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage , totalPage));
            paginationHtml = paginationHtml.replace(/{{last}}/g, pageLastHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }


            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);

            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);


            jQ(this.selector.bottomPagination).html(paginationHtml);
        }
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml;
            html = html.replace(/{{sortingItems}}/g, sortingItemsHtml);
            html = html.replace(/{{productsOnPage}}/g, texttodisplay);
                
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  this.buildRobotsMetaTag();};


function onInteractWithFilterOptionValue(event, element, filterType, displayType, selectType, keepValuesStatic) {
    if (bcsffilter.isMobile() && bcsffilter.mobileStyle == 'style2') {
        // Prevent reloading page
        event.preventDefault();
        if (jQ(element).data('count') > 0) {
            // This is action of clicking of user, not browser event
            bcsffilter.internalClick = true;
            if (selectType == 'single') {
                jQ('.bc-sf-filter-option-block-active').find('ul li').children().removeClass('selected');
            }
            // Highlight selected filter options
            jQ(element).toggleClass('selected');
            jQ(element).siblings().toggleClass('selected');
            // Build 
            bcsffilter.buildFilterSelectionMobile();
        }
    } else {
        var keepValuesStatic = typeof keepValuesStatic !== 'undefined' ? (keepValuesStatic === 'true') : false;
        if (keepValuesStatic === false && displayType != 'sub_category') {
            // Prevent reloading page
            event.preventDefault();
            if (jQ(element).data('count') > 0 || jQ(element).data('count') == undefined) {
                // This is action of clicking of user, not browser event
                bcsffilter.internalClick = true;
                // Get value of the filter option selected
                var id = jQ(element).attr('data-id');
                var value = decodeURIComponent(jQ(element).attr('data-value'));
                // Set value collectionId for data of collection_scope used in API params
                if (filterType == 'collection') {
                    bcsffilter.queryParams.collection_scope = bcsffilter.collectionId = jQ(element).data('collection-scope');
                    // bcsffilter.buildPageInfo();
                }
                // Build new url
                var newUrl = ((displayType == 'list' || displayType == 'sub_category') && selectType == 'single') ? jQ(element).attr('href') : bcsffilter.buildFilterOptionLink(id, value, filterType, displayType, selectType);
                bcsffilter.onChangeData(newUrl, filterType, value, id);
            }
        }
    }
    jQ("html, body").animate({ scrollTop: 0 }, "slow");
 
}
/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
